import "./styles.css";

export default () => (
  <div className="rdw-spinner">
    <div className="rdw-bounce1" />
    <div className="rdw-bounce2" />
    <div className="rdw-bounce3" />
  </div>
);
